import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { MammothMascot } from "../components/MammothMascot";
import { Lock, Check } from "lucide-react";

export default function Levels() {
  const [levels, setLevels] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    api.get("/levels").then(r => setLevels(r.data.levels)).catch(() => {});
  }, []);

  return (
    <div className="animate-fadeUp" data-testid="levels-page">
      {/* keyframe for the "you are here" mammoth-circle pulse */}
      <style>{`
        @keyframes mlStagePulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(14,32,59,0.45); transform: scale(1); }
          50%      { box-shadow: 0 0 0 18px rgba(14,32,59,0); transform: scale(1.04); }
        }
        .ml-stage-current {
          border-radius: 9999px;
          animation: mlStagePulse 2.4s ease-in-out infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .ml-stage-current { animation: none !important; }
        }
      `}</style>
      <div className="text-xs font-bold uppercase tracking-[0.25em] opacity-60">Your path</div>
      <h1 className="font-display font-black text-4xl tracking-tighter mt-2">Stages of training</h1>
      <p className="opacity-70 mt-2 max-w-xl">Your background shifts with you. Same mammoth, same you — new aesthetic to settle into.</p>

      <div className="mt-10 space-y-4">
        {levels.map(l => {
          const unlocked = (user?.current_level || 1) >= l.level;
          const current = user?.current_level === l.level;
          return (
            <div
              key={l.level}
              data-testid={`level-row-${l.level}`}
              className={`rounded-3xl p-6 shadow-md border-2 flex items-center gap-6 transition-all ${current ? "border-[#0e203b]" : "border-[#0e203b]/5"}`}
              style={{ backgroundColor: l.background, color: l.text }}
            >
              <MammothMascot size="clamp(64px, 9vw, 96px)" stage={l.level} shape="circle" className="flex-shrink-0" />
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <div className="text-xs font-bold uppercase tracking-widest opacity-60">Stage {l.level}</div>
                  {current && <span className="text-xs font-bold bg-[#0e203b] text-white rounded-full px-2 py-0.5">Now</span>}
                </div>
                <div className="font-display font-black text-2xl tracking-tighter">{l.name}</div>
                <div className="text-sm opacity-70 mt-1">{l.aesthetic} · {l.tagline}</div>
                <div className="text-xs mt-2 opacity-60">Unlocks at {l.xp_required} XP</div>
              </div>
              <div className="flex flex-col items-center gap-2">
                <div
                  className={`h-12 w-12 rounded-full ${current ? "ml-stage-current" : ""}`}
                  style={{ backgroundColor: l.accent }}
                ></div>
                {unlocked ? <Check size={16} /> : <Lock size={16} />}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
